import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {ClientDetailsResponse} from '../../../account/my-account/model/agentDetailsResponse.model';
@Component({
  selector: 'terra-high-holidays-notification',
  templateUrl: './high-holidays-notification.component.html',
  styleUrls: ['./high-holidays-notification.component.scss']
})
export class HighHolidaysNotificationComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public userDetails: ClientDetailsResponse,
    private sanitizer: DomSanitizer
  ) { }
  title: string;
  description: SafeHtml;
  ngOnInit() {
    this.title = this.userDetails.holidayPopupTitle;
    const formattedDescription: string = this.userDetails.holidayPopupDescription.replace(/\\n/g, '<br/>');
    this.description = this.sanitizer.bypassSecurityTrustHtml(formattedDescription);
  }
}
